module.exports = __webpack_public_path__ + "static/x86-appcp.4760d810.png";